:host {
  display: block;
}
.line-items {
  display: grid;
  gap: var(--sc-spacing-small);
}
.line-item {
  display: grid;
  gap: var(--sc-spacing-small);
}
.fee__description {
  opacity: 0.75;
}
